import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../../Actions/LanguageAction";
import LeaveUsageLimit from "./LeaveUsageLimit";
import ReqAttachment from "./ReqAttachment";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
class UsagePolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  render() {
    const language = this.props.Language.reqattachment;
    return (
      <IntlProvider locale="en" messages={language}>
        {/* <Grid container> */}
        <Grid item xs={12} md={12} sm={12}>
          <div className="margin-top-20">
            <p className="form-main-header">
              <FormattedMessage
                id="LbUsagePolicy"
                defaultMessage="Usage Policy"
              />
            </p>
            <p className="form-sub-header">
              <FormattedMessage
                id="LbConfigureLeaveUsage"
                defaultMessage="Now, let’s configure the leave usage policy below"
              />
            </p>
            <ReqAttachment
              ParentIndex={this.state.ParentIndex}
              leavetypeid={this.state.leavetypeid}
            />
            <LeaveUsageLimit
              ParentIndex={this.state.ParentIndex}
              leavetypeid={this.state.leavetypeid}
            />
          </div>
          {/* </Grid> */}
        </Grid>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(UsagePolicy)));
